import { render } from "./MesInformations.vue?vue&type=template&id=e047d06c"
import script from "./MesInformations.vue?vue&type=script&lang=js"
export * from "./MesInformations.vue?vue&type=script&lang=js"
script.render = render

export default script